























import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { MyDetails } from '../../models/MyPlayerDetails';
import { PlayerRole } from '../../models/PlayerRole';

@Component({})
export default class PlayerDetailsForm extends Vue {
  @Prop({ required: true }) playerDetails!: MyDetails | null;
  @Prop({ required: true }) callback!: (playerName: MyDetails) => void;

  playerName: string | null = null;
  playerRole: PlayerRole | null = PlayerRole.Player;

  updatePlayerDetails() {
    this.callback(this.getCallbackResult());
    this.$emit('close');
  }

  @Watch('playerDetails')
  setPlayerDetails() {
    this.playerName = this.playerDetails?.name || null;
    this.playerRole = this.playerDetails?.role || null;
  }

  created() {
    this.setPlayerDetails();
  }

  private getCallbackResult(): MyDetails {
    return {
      name: this.playerName as string,
      role: this.playerRole as PlayerRole
    };
  }
}
